
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// polyfills
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'picturefill';

import '../css/app.css'

// Import static assets
import './static.assets';

// Set background images lazily
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

import Headroom from './components/ui/Headroom'
import HeaderSearch from './components/ui/HeaderSearch'
import MobileNav from './components/ui/MobileNav'
import SmoothAnchor from './components/ui/SmoothAnchor'
import VenveoApplication from "./base/VenveoApplication";
import Glightbox from './components/ui/Glightbox';
import Accordions from './components/ui/Accordion';
import PlyrHero from './components/ui/PlyrHero';
import ReadMoreProse from './components/ui/ReadMoreProse';
import TestimonialSlider from './components/ui/sliders/TestimonialSlider';
import ResourceFinder from './components/pages/ResourceFinder';
import DropdownFilters from './components/ui/DropdownFilters';

const application = new VenveoApplication();
application.registerComponent('header', 'header', Headroom)
application.registerComponent('header-search', '[data-header-search]', HeaderSearch)
application.registerComponent('mobile-nav', '[data-mobile-nav]', MobileNav)
application.registerComponent('glightbox', '.glightbox', Glightbox)
application.registerComponent('accordion', '[data-accordion]', Accordions)
application.registerComponent('smooth-scroll', 'header', SmoothAnchor)
application.registerComponent('plyr-hero', '#plyrhero-video', PlyrHero)
application.registerComponent('read-more', '[data-readmore]', ReadMoreProse)
application.registerComponent('testimonial-slider', '#testimonialSlider', TestimonialSlider)
application.registerComponent('resource-finder', '#resource-finder', ResourceFinder)
application.registerComponent('dropdown-filters', '[data-dropdown-filter]', DropdownFilters)

application.init().then(() => {
    // console.log('Site is ready.')
})

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept();
}
